<template>
  <div>
    <el-tooltip :content="$t('accountAdditionalDetails.delete.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button size="md" icon round type="danger" @click.native="handleDelete()" :disabled="updating"
                   class="zi_100">
        <span class="mdi mdi_icon mdi-24px mdi-close"/>
      </base-button>
    </el-tooltip>

  </div>
</template>


<script>
import swal from "sweetalert2";
import {mapActions, mapState} from "vuex";

export default {
  name: 'DeleteAccountAdditionalDetailsBtn',
  components: {},
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      updating: state => state.account_additional_details.updating,
      error: state => state.account_additional_details.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['DeleteAccountAdditionalDetails', 'LoadAccount']),
    handleDelete() {
      swal({
        title: this.$t('accountAdditionalDetails.delete.text'),
        text: `'${this.details.data.personal_data.person_identifier}'`,
        confirmButtonText: this.$t('accountAdditionalDetails.delete.actionBtnLabel'),
        cancelButtonText: this.$t('accountAdditionalDetails.delete.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.DeleteAccountAdditionalDetails({accountId: this.details.account_id, id: this.details.id}).then(() => {
            if (this.error == null) {
              this.$notify({
                type: 'success',
                message: this.$t('accountAdditionalDetails.delete.successNotification'),
                icon: 'tim-icons icon-alert-circle-exc'
              })
              this.LoadAccount(this.details.account_id)
            }
          })
        }
      });
    },
  }
}
</script>
